import i18next, { type i18n as I18n } from "i18next";
import { applyLocale } from "../../../i18n/applyLocale";

export type ObLocale = "en" | "ar";

/** The active UI locale, normalised to the two the suite ships. */
export function currentObLocale(language: string | undefined = i18next.language): ObLocale {
  return language?.startsWith("ar") ? "ar" : "en";
}

/**
 * Switch the suite's UI language — the same three steps the topbar and
 * LoginScreen EN/ع toggles take (persist `weco-locale`, change i18next,
 * set <html dir/lang>), plus the `weco-locale-updated` event the shell and
 * suite chrome listen for so an already-mounted shell follows along.
 */
export function setObLocale(next: ObLocale, instance: Pick<I18n, "changeLanguage"> = i18next): void {
  try {
    localStorage.setItem("weco-locale", next);
  } catch {
    /* storage blocked — the in-memory switch below still applies */
  }
  void instance.changeLanguage(next);
  applyLocale(next);
  window.dispatchEvent(new Event("weco-locale-updated"));
}
